@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.admin.dynamicroles

import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.router.EndPoint


object DeleteAdminDynamicRoleEndpoint : EndPoint<DeleteAdminDynamicRoleEndpoint.Request, DeleteAdminDynamicRoleEndpoint.Response>() {
    class Request(
            val itemId: KmmLong
    )

    class Response
}

